export default __webpack_public_path__ + "static/media/Alrahim.49012ebc.jpg";